import React, { useEffect } from "react";
import "./Our_Blogs.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AllBlogs } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const Our_Blogs = ({ blogs }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBlogClick = (blog) => {
    navigate(`/blog/${blog.id}`, { state: blog });
  };
  // const blogData = [
  //   {
  //     id: 1,
  //     image: "/assets/images/home/Our_Blogs/img-1.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },

  //   {
  //     id: 2,
  //     image: "/assets/images/home/Our_Blogs/img-2.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },

  //   {
  //     id: 3,
  //     image: "/assets/images/home/Our_Blogs/img-3.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },
  // ];

  return (
    <section className="Our_Blogs">
      <div className="container">
        <div className="Our_Blogs_header">
          <h5>
            Our <span>Blogs</span>
          </h5>
        </div>

        <div className="blog_section">
          <div className="row">
            {blogs?.slice(0, 3).map((post) => (
              <div
                className="col-lg-4 col-md-6 col-sm-6 col-12 mb-4"
                key={post.id}
              >
                <div
                  className="blog_card card"
                  onClick={() => handleBlogClick(post)}
                >
                  <div className="card-body p-0">
                    <div className="blog_img_div">
                      <img
                        src={`${IDS.IMG_URL}${post.image}`}
                        alt={post.heading}
                        className="blog_img"
                      />
                    </div>

                    <div className="category_title">
                      <h5 className="post_title">{post.heading}</h5>
                      <p className="post_date">
                        <span>
                          <FontAwesomeIcon
                            icon={faCalendar}
                            style={{ color: "#BFBFBF" }}
                          />
                        </span>{" "}
                        {""}
                        {new Date(post.created_at).toDateString()}{" "}
                      </p>
                    </div>

                    <p
                      className="post_desc"
                      dangerouslySetInnerHTML={{
                        __html: post.description.slice(0, 120) + "...",
                      }}
                    />
                  </div>
                  <div className="card-footer p-0">
                    <div className="read_more_div">
                      <button
                        className="read_more_btn"
                        onClick={() => handleBlogClick(post)}
                      >
                        Read More
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="see_more_div">
            <button className="see_more" onClick={() => navigate("/blogs")}>
              {" "}
              See All
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Our_Blogs;
